<template>
    <v-footer class="pa-0">
        <v-layout row style="margin-left: 0px;margin-right: 0px">
            <v-flex class="col-md-4 col-12" style="background-color: #F2F2F2">
                <v-flex offset-md4 :style="$vuetify.breakpoint.smAndDown ? {'text-align':' center'}:{'text-align':'start'}">
                    <v-btn class="pl-1 mb-5 mt-5"  @click="$router.push('/')" style="background-color: #F2F2F2;box-shadow: none;font-weight: bold;font-size: 18px;height: 60px;padding: 0px"><v-img style="z-index: 8"  :style="$vuetify.breakpoint.smAndDown ? {'width':'50px'}:''" :src="require('../assets/Frame.png')"></v-img></v-btn>
                    <h2 style="color: #1353DB;font-size: 20px;font-weight: 600;line-height: 46px;font-style: normal"
                    >DC ONE WALLET</h2>
                </v-flex>
            </v-flex>
            <v-flex class="col-md-8 col-12">
                <v-layout row pt-5 ma-0 :style="$vuetify.breakpoint.smAndDown ? {'justify-content':' center'}:{'justify-content':'start'}">
                    <v-flex offset-md1 class="col-4 mr-3">
                        <p style="font-size: 13px">COMPANY</p>
                        <hr class="mb-5">
                        <p style="font-size: 13px">Deposit</p>
                        <p style="font-size: 13px">Withdraw</p>
                        <p style="font-size: 13px">Transfer</p>
                        <p style="font-size: 13px">QR Code</p>
                        <p style="font-size: 13px">API</p>
                    </v-flex>
                    <v-flex class="col-4">
                        <p style="font-size: 13px">SOCIAL</p>
                        <hr class="mb-5">
                        <p style="font-size: 13px">Facebook</p>
                        <p style="font-size: 13px">Twitter</p>
                        <p style="font-size: 13px">Linkedln</p>
                        <p style="font-size: 13px">Instagram</p>
                        <p style="font-size: 13px">Reddit</p>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>
